import { Cache } from 'aws-amplify/utils';

export const createCacheInstance = (keyPrefix: string) => {
  const defaultConfig = Cache.configure();

  return Cache.createInstance({ ...defaultConfig, keyPrefix });
};

export default createCacheInstance;